import {createContext, useContext} from 'react';

const ErrorContext = createContext();

export const useError = () => useContext(ErrorContext);

export default ErrorContext;
